import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../app/appConstants";

export const LoginWrapperStyled = styled.div`
    display: flex;
    flex-direction: column;

    > a {
        color: unset;
        text-decoration: underline;
    }
`;

export const LoginStyled = styled.div`
    width: 464px;
    margin: 64px auto;
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin: 0 auto;
        width: 100%;
        background: var(--color-bg-modal);
    }
`;

export const LoginBoxStyled = styled.div`
    background: var(--color-bg-modal);
    //box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 30px 44px -20px rgb(39, 238, 214, 0.7);
    border-radius: 24px;
    padding: 32px 40px;
    position: relative;
    @media (max-width: ${BREAKPOINTS.small}px) {
        box-shadow: none;
        padding: 24px 16px;
    }
`;

export const LoginForgotPasswordLinkContainerStyled = styled.div`
    display: flex;
    justify-content: end;
    margin-bottom: 32px;

    a {
        color: var(--color-white);
    }
`;
